export const SORT_TYPES = {
  text: { asc: 'A → Z', desc: 'Z → A' },
  date: { asc: 'Earliest → Latest', desc: 'Latest → Earliest' },
};

export const SHOW_TRACKER_COLUMNS = [
  { id: '_copy', label: 'Copy', defaultVisible: true, alwaysVisible: true, sortable: false, sortType: 'text' },
  { id: 'event_name', label: 'Event Name', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_date', label: 'Date', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'day', label: 'Day', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'headliner', label: 'Headliner', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'support', label: 'Support', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'ages', label: 'Ages', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'announce_date', label: 'Announce Date', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'announce_time', label: 'Announce Time', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'presale_date', label: 'Venue Presale Date', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'presale_time', label: 'Venue Presale Time', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'onsale_date', label: 'Onsale Date', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'onsale_time', label: 'Onsale Time', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'friday_of_onsale', label: 'Friday of Onsale', defaultVisible: true, sortable: false, sortType: 'date' },
  { id: 'url', label: 'Opendate URL', defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'website_url', label: 'Website URL', defaultVisible: true, sortable: false, sortType: 'text' },
];

export const getDefaultVisibleColumns = () =>
  SHOW_TRACKER_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  SHOW_TRACKER_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
